export default {
  props: {
    dashboardData:    { type: Object, default: () => undefined },
    threshold:        { type: Array, required: true }
  },

  data: function() {
    return {
      // This is a legacy counter which is needed to perform counting.
      // TODO: If time, rework this
      RefreshCounter: 0 /* Hack / Workaround */
    }
  },

  computed: {
    actionManagementCenter_ExpData: function() {
      return Object.values(this.dashboardData.Exploration || [])
                   .filter(i => !_.isNumber(i) && !_.isArray(i) && this.checkApiThreshold(i) &&
                                i.Threshold?.Value != null && !i.Inactive);
    },

    actionManagementCenter_ExpAugData: function() {
      if (!this.dashboardData || 
          !this.dashboardData.ExplorationAugmention ||
          !this.dashboardData.ExplorationAugmention.Categories) {
        return [];
      }
      return _.flatMap(this.dashboardData.ExplorationAugmention.Categories, 'AFSItems') || [];
    },

    resolvedValue: function() {
      return ((this.resolved / (this.maxResolvable || 1)) * 100).toFixed(0);
    },

    unresolvedValue: function() {
      return 100 - this.resolvedValue + (this.RefreshCounter * 0);
    },

    maxResolvable: function() {
      // Do only count elements that are not accomplished
      const apis = this.actionManagementCenter_ExpData.filter(i => !this.checkIsAccomplished(i))?.length || 0;
      const afs  = this.actionManagementCenter_ExpAugData.filter(i => !this.checkIsAccomplished(i))?.length || 0;
      return apis + afs + this.resolved + (this.RefreshCounter * 0);
    },

    resolved: function() {
      // Do only count items that are valid for the AMC
      const validApis = this.actionManagementCenter_ExpData;
      const apis = this.dashboardData?.Exploration?.ResolvedApis?.filter(i => validApis.find(a => i.ApiID == a.ApiID))?.length || 0;
      const afs = this.getResolvedApisFromSurveys().length;

      return apis + afs + (this.RefreshCounter * 0);
    }
  },

  methods: {
    getResolvedApisFromSurveys() {
      return this.dashboardData && this.dashboardData.ExplorationAugmention 
        ? this.dashboardData.ExplorationAugmention.ResolvedApisFromSurveys || []
        : [];
    },

    checkApiThreshold(api) {
      return api?.Threshold?.Value < api?.Threshold?.Threshold;
    },

    checkIsAccomplished(obj) {
      return (obj?.IsAccomplished || obj?.Threshold?.IsAccomplished) === true;
    },

    resolvedFirstAidKit(firstAidKitGroupId) {
      if (this.dashboardData.Exploration) {
        Object.values(this.dashboardData.Exploration)
          .filter(o => o instanceof Object && o.ApiID && !o.Inactive)
          .forEach(api => {
            if (api.FirstAidKit?.FirstAidKit != firstAidKitGroupId)
              return;

            // Mark only valid and not accomplished apis as resolved
            if (!api.Threshold || api.Threshold.IsAccomplished)
              return;

            api.Threshold.IsAccomplished = true;
            this.dashboardData.Exploration.ResolvedApis.push({ ApiID: api.ApiID });
          });
      }

      if (this.dashboardData.ExplorationAugmention) {
        this.dashboardData.ExplorationAugmention.Categories?.forEach(c => {
          c.AFSItems?.forEach(afs => {
            if (afs?.IsAccomplished || afs?.FirstAidKit?.FirstAidKit != firstAidKitGroupId)
              return;

            afs.IsAccomplished = true;

            this.getResolvedApisFromSurveys().push({ ExternalSurveyId: afs.ExternalSurveyId });
          });
        });
      }

      this.RefreshCounter++;
    },

    getColor(value) {
      if (!this.threshold) return null;

      return this.threshold.find(
        (thres) => thres.Minimum <= value && thres.Maximum >= value
      )?.Color;
    }
  }
}
